import {
  formatPostingTimeMetricPercent,
  formatPostsPublishedLabel,
  hasSlotPerformanceData,
  OPTIMAL_POSTING_HIGHEST_PERFORMING_LABEL,
  OPTIMAL_POSTING_PERFORMANCE_LABELS,
  OPTIMAL_POSTING_SLOT_EMPTY_MESSAGE,
  OPTIMAL_POSTING_TIER_TEXT_COLORS,
} from '../utils/optimalPostingTimesUtils'

function MetricRow({ label, value }) {
  return (
    <div className="optimalPostingTimesSlotTooltip__metric">
      <div className="optimalPostingTimesSlotTooltip__metricLabel">{label}</div>
      <div className="optimalPostingTimesSlotTooltip__metricValue dashboard-tabular-nums">{value}</div>
    </div>
  )
}

export default function OptimalPostingTimesSlotTooltip({
  header,
  postCount,
  tierLevel,
  minPostsPerSlot = 1,
  performanceVsPeak = null,
  shareOfTotalEngagement = null,
  isHighestPerforming = false,
  hasValidPosts = true,
}) {
  const showPerformance = hasValidPosts && hasSlotPerformanceData(postCount, tierLevel, minPostsPerSlot)

  if (!showPerformance) {
    return (
      <div className="rg-chart__tooltip rg-chart__tooltip--campaign optimalPostingTimesBarTooltipPanel optimalPostingTimesSlotTooltip">
        <div className="optimalPostingTimesSlotTooltip__header">{header}</div>
        <p className="optimalPostingTimesSlotTooltip__empty">{OPTIMAL_POSTING_SLOT_EMPTY_MESSAGE}</p>
      </div>
    )
  }

  return (
    <div className="rg-chart__tooltip rg-chart__tooltip--campaign optimalPostingTimesBarTooltipPanel optimalPostingTimesSlotTooltip">
      <div className="optimalPostingTimesSlotTooltip__header">{header}</div>
      <div className="optimalPostingTimesSlotTooltip__posts">{formatPostsPublishedLabel(postCount)}</div>

      <div className="optimalPostingTimesSlotTooltip__metrics">
        {isHighestPerforming ? (
          <div className="optimalPostingTimesSlotTooltip__peakLabel">
            {OPTIMAL_POSTING_HIGHEST_PERFORMING_LABEL}
          </div>
        ) : (
          <MetricRow
            label="Performance vs. peak"
            value={formatPostingTimeMetricPercent(performanceVsPeak)}
          />
        )}
        <MetricRow
          label="Share of total engagement"
          value={formatPostingTimeMetricPercent(shareOfTotalEngagement)}
        />
      </div>

      <div
        className="optimalPostingTimesSlotTooltip__tier"
        style={{ color: OPTIMAL_POSTING_TIER_TEXT_COLORS[tierLevel] }}
      >
        {OPTIMAL_POSTING_PERFORMANCE_LABELS[tierLevel]}
      </div>
    </div>
  )
}
